 
 
 
import TextField from "@material-ui/core/TextField";
 
import OutlinedInput from "@material-ui/core/OutlinedInput";


const index = ({handleClick,InputProps,additionClass,loading=false,label,htmlFor,tName,type,endAdornment,handleChange,value,additionLabelClass,error,placeholder,multiline}) => {
    return (
            <>
                {handleClick === undefined  ? (
                       <OutlinedInput
                            type={type}
                            readOnly={loading}
                            className={additionClass}
                            placeholder={value}
                            id={htmlFor}
                            InputProps={InputProps}
                            name={tName}
                            value={value}
                            error={error}
                            variant="outlined"
                            onChange={handleChange}
                            endAdornment={endAdornment}
                        
                        />
                ):(

                    <OutlinedInput
                        type={type}
                        readOnly={loading}
                        className={additionClass}
                        placeholder={value}
                        id={htmlFor}
                        InputProps={InputProps}
                        name={tName}
                        value={value}
                        error={error}
                        variant="outlined"
                        onChange={handleChange}
                        onClick={handleClick}
                        endAdornment={endAdornment}
                
                />
                    
                )}
            </>
        
    );
  }
  
  export default index;
  